import React from 'react';

import { Chip, Table, TableBody, TableCell, TableRow, Tooltip, Typography } from '@mui/material';

import { MATCH_TIER_DESCRIPTIONS, PAPER_TOOLTIP_SX } from './constants';
import { isAutoVerifiedMatch } from './utils';

const MATCH_TIERS = Object.keys(MATCH_TIER_DESCRIPTIONS).map(Number);

interface Props {
  matchTier: number | undefined;
}

export default function CompetitorOfferMatchChip({ matchTier }: Props) {
  if (matchTier === undefined) {
    return null;
  }

  return (
    <Tooltip
      slotProps={{ tooltip: { sx: PAPER_TOOLTIP_SX } }}
      title={
        <>
          <Table size="small">
            <TableBody>
              {MATCH_TIERS.map((tier) => (
                <TableRow key={tier} selected={tier === matchTier}>
                  <TableCell sx={{ whiteSpace: 'nowrap', fontWeight: tier === matchTier ? 'bold' : undefined }}>
                    Tier {tier}
                  </TableCell>
                  <TableCell sx={{ fontWeight: tier === matchTier ? 'bold' : undefined }}>
                    {MATCH_TIER_DESCRIPTIONS[tier]}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Typography variant="caption" color="text.secondary" component="p" px={2} pt={1}>
            Auto Matching makes mistakes
          </Typography>
        </>
      }
    >
      <Chip
        size="small"
        color={isAutoVerifiedMatch(matchTier) ? 'primary' : 'warning'}
        label={`Tier ${matchTier} Matching`}
      />
    </Tooltip>
  );
}
